const cases = [
  {
    icon: "ri-map-pin-2-line",
    title: "某国家级开发区",
    stat: "规划面积 85平方公里",
    desc: "通过产业链匹配算法精准定位目标企业，半年内新增签约项目47个，总投资额超320亿元，项目平均落地周期从9个月缩短至3个月。",
    color: "from-blue-500 to-indigo-500",
  },
  {
    icon: "ri-building-2-line",
    title: "某省级高新技术产业园",
    stat: "入驻企业 680家",
    desc: "智能匹配评分系统上线后，企业需求与园区供给匹配度从62%提升至86%，流失预警机制帮助企业挽回意向项目12个，年度产值增长28%。",
    color: "from-emerald-500 to-teal-400",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "某市级招商引资平台",
    stat: "在谈项目 240个",
    desc: "全生命周期数字化跟踪实现项目进度100%透明，领导决策效率提升3倍，年度签约项目数同比增长55%，获评省级招商示范平台。",
    color: "from-amber-500 to-orange-400",
  },
  {
    icon: "ri-community-line",
    title: "某县域特色产业招商",
    stat: "覆盖产业 6大集群",
    desc: "竞品园区监测系统实时掌握企业动态，提前介入意向流失企业，成功挽留重点项目8个，带动上下游配套企业落户23家。",
    color: "from-violet-500 to-purple-400",
  },
];

export default function IMCases() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">Implementation Cases</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">招商落地案例</h2>
          <p className="text-slate-500 text-sm max-w-lg mx-auto">已在国家级开发区、省级产业园等成功部署运营</p>
        </div>

        <div className="grid grid-cols-2 gap-6">
          {cases.map((c) => (
            <div key={c.title} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 hover:border-indigo-200 transition-all group">
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center bg-gradient-to-br ${c.color} flex-shrink-0 group-hover:scale-105 transition-transform`}>
                  <i className={`${c.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-slate-800 font-semibold text-lg">{c.title}</h3>
                    <span className="text-xs bg-white border border-slate-200 text-slate-500 px-2 py-0.5 rounded-full">{c.stat}</span>
                  </div>
                  <p className="text-slate-500 text-sm leading-relaxed">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
